/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One user row in a bulk import request.
 * @export
 * @interface UserImportItem
 */
export interface UserImportItem {
    /**
     * 
     * @type {string}
     * @memberof UserImportItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserImportItem
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserImportItem
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserImportItem
     */
    last_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserImportItem
     */
    grade?: number | null;
}

/**
 * Check if a given object implements the UserImportItem interface.
 */
export function instanceOfUserImportItem(value: object): value is UserImportItem {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserImportItemFromJSON(json: any): UserImportItem {
    return UserImportItemFromJSONTyped(json, false);
}

export function UserImportItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportItem {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'username': json['username'] == null ? undefined : json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'grade': json['grade'] == null ? undefined : json['grade'],
    };
}

export function UserImportItemToJSON(json: any): UserImportItem {
    return UserImportItemToJSONTyped(json, false);
}

export function UserImportItemToJSONTyped(value?: UserImportItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'grade': value['grade'],
    };
}

